import { observable, action, runInAction, computed} from 'mobx'
import { message } from 'antd'
import { json , get } from '../../../../utils/ajax'

class hoursStepManagerStore {

    @observable timeStepList
    @observable loading
    @observable pagination
    @observable form
    @observable modal
    @observable stepId

    constructor() {
        this.timeStepList = []
        this.loading = false
        this.pagination = {}
        this.form = {}
        this.modal = 'hide'
        this.stepId = ''
    }

    /**
     * 步骤列表
     * 分页
     */
    @action
    initListStep = async (page,value) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        // 构建查询参数
        let search = value || ''
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/step/hierarchyList`,{
            page : page,
            code : search
        })
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.timeStepList = res.content
            this.pagination = {
                total: res.totalElements,
                page: res.number + 1,
            }
            this.loading = false
        })
    }

    /**
     * 删除
     */
    @action
    deleteStep = async(id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/step/delete?id=${id}`)
        if (res && res.status >= 400) {
            return
        }
        runInAction(() => {
            message.success('删除成功')
            this.loading = false
        })
        if(this.timeStepList.length === 1){
            await this.initListStep(this.pagination.page -1)
        }else{
            await this.initListStep(this.pagination.page)
        }
    }

    /**
     * 用于修改初始化表单
     * 根据id查询
     */
    @action
    initEdit = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/step/id/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.stepId = id
            this.form = res
            this.loading = false
            this.modal = 'show'
        })
    }

    /**
     * 平行化表单，传值给form
     */
    @computed
    get fields() {
        let fields = {
            timeCode: {value: this.form.timeCode},
            stepNumber: {value: this.form.stepNumber},
            step: {value: this.form.step},
            time: {value: this.form.time}
        }
        return fields
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action
    onFormsChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let form = {
            timeCode: fields.timeCode.value,
            stepNumber: fields.stepNumber.value,
            step: fields.step.value,
            time: fields.time.value
        }
        this.form = form
    }

    /**
     * 关闭form编辑框
     */
    @action
    showModal = () => {
        runInAction(() => {
            this.loading = true
            this.modal = 'hide'
            this.loading = false
        })
    }

    /**
     * 修改步骤
     */
    @action
    saveStep = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res1 = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/step/list?id=${this.stepId}`)
        for(let item of res1){
            if(item.timeCode === this.form.timeCode && item.stepNumber === this.form.stepNumber){
                message.info('该步骤已存在，请检查!')
                return
            }
        }
        let data = {
            id: this.stepId,
            timeCode: this.form.timeCode,
            stepNumber: this.form.stepNumber,
            step: this.form.step,
            time: this.form.time
        }
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/step/update`,data)
        if (res && res.status >= 400) {
            message.error('修改失败')
            return
        } else {
            runInAction(() => {
                this.modal = 'hide'
                message.success('修改成功')
                this.form = {}
                this.loading = false
            })
            await this.initListStep()
        }
    }
}
export default new hoursStepManagerStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/HoursManual/HoursStepManager/store.js